import { post, get } from './client';
import { makeGrowerPath } from './utils';

export function runSoyRx(aaid) {
  return post(makeGrowerPath(`/soyrx/run/${aaid}`));
}

export function getSoyEarlyStats(aaid) {
  return get(makeGrowerPath(`/soyrx/early-stats/${aaid}`));
}

export function getSoyLateStats(aaid) {
  return get(makeGrowerPath(`/soyrx/late-stats/${aaid}`));
}

export function getSoyEarlyAdjustedGroups(aaid) {
  return get(makeGrowerPath(`/soyrx/early-group-adjustment/${aaid}`));
}

export function getSoyLateAdjustedGroups(aaid) {
  return get(makeGrowerPath(`/soyrx/late-group-adjustment/${aaid}`));
}

export function getSoyRxForGrower(growerId) {
  return get(`/soyrx/by-grower/${growerId}`);
}

export function setSoyEarlyAdjustmentFactor(aaId, adjustmentFactor) {
  return post(makeGrowerPath(`/soyrx/adjustment-factor/${aaId}/early`), {
    adjustmentFactor,
  });
}

export function setSoyLateAdjustmentFactor(aaId, adjustmentFactor) {
  return post(makeGrowerPath(`/soyrx/adjustment-factor/${aaId}/late`), {
    adjustmentFactor,
  });
}

export function setSoyRxEarlyGroupAdjustment(aaId, groupAdjustments) {
  return post(
    makeGrowerPath(`/soyrx/early-group-adjustment/${aaId}`),
    groupAdjustments,
  );
}

export function setSoyRxLateGroupAdjustment(aaId, groupAdjustments) {
  return post(
    makeGrowerPath(`/soyrx/late-group-adjustment/${aaId}`),
    groupAdjustments,
  );
}

export function getSoyRxEarlyGroupAdjustment(aaId) {
  return get(makeGrowerPath(`/soyrx/early-group-adjustment/${aaId}`));
}

export function getSoyRxLateGroupAdjustment(aaId) {
  return get(makeGrowerPath(`/soyrx/late-group-adjustment/${aaId}`));
}
